export default "__VITE_ASSET__DNXbXRK1__"